'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FileProgress(_ref) {
  var savedProgress = _ref.savedProgress;

  var progressStr = savedProgress + '%';

  return _react2.default.createElement(
    'div',
    { className: 'dz-progress progress' },
    _react2.default.createElement(
      'div',
      {
        className: 'progress-bar',
        role: 'progressbar',
        style: { backgroundColor: 'lightgreen', width: progressStr },
        'aria-valuenow': savedProgress,
        'aria-valuemin': '0',
        'aria-valuemax': '100'
      },
      progressStr
    )
  );
}
FileProgress.propTypes = {
  savedProgress: _propTypes2.default.number.isRequired
};
FileProgress.defaultProps = {
  width: 300
};
exports.default = FileProgress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/FileProgress.js
// module id = 685
// module chunks = 0